<div class="workflow-card">
  <div class="workflow-table-wrapper">
    <div class="workflow-layout" [class.no-columns]="(columns?.length || 0) === 0">
      <div class="workflow-left-panel">
        <div class="workflow-left-header workflow-title">
          <wm-common-text [data]="{ text: 'Workflows' }"></wm-common-text>
        </div>

        <div class="workflow-left-body">
          <div class="workflow-row" *ngIf="(rows?.length || 0) === 0">
            <div class="workflow-selected">
              <wm-common-text [data]="{ text: 'All Workflows' }"></wm-common-text>

              <div class="workflow-actions filter-wrapper">
                <button type="button" class="icon-btn">
                  <mat-icon>filter_alt</mat-icon>
                </button>
              </div>
            </div>
          </div>

          <div
            class="workflow-row"
            #workflowRowElement
            *ngFor="let row of rows; let i = index; trackBy: trackRowByWorkflow">
            <ng-container *ngIf="!row.workflowId">
              <div class="workflow-dropdown">
                <div
                  class="workflow-dropdown-trigger workflow-title-name"
                  (click)="toggleDropdown(i, $event)">
                  <wm-common-text
                    [data]="{ text: getWorkflowDisplayName(row.workflowId) }">
                  </wm-common-text>
                </div>

                <div
                  class="workflow-dropdown-panel"
                  *ngIf="activeDropdown === i"
                  [style.top.px]="workflowDropdownBottom === null ? workflowDropdownTop : null"
                  [style.bottom.px]="workflowDropdownBottom"
                  [style.left.px]="workflowDropdownLeft">
                  <div
                    class="workflow-option"
                    *ngFor="let wf of availableWorkflows"
                    (click)="selectWorkflow(i, wf)">
                    {{ wf.version?.name || wf.name }}
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-container *ngIf="row.workflowId">
              <div class="workflow-content">
                <div class="workflow-selected">
                  <wm-common-text
                    [data]="{ text: getWorkflowDisplayName(row.workflowId, row.workflowId) }">
                  </wm-common-text>

                  <div class="workflow-actions">
                    <button type="button" class="icon-btn" (click)="deleteWorkflow(i)">
                      <mat-icon>delete</mat-icon>
                    </button>

                    <wm-filter-builder
                      *ngIf="row.workflowId && row.filterParams"
                      [id]="row.filterBuilderId"
                      [params]="row.filterParams"
                      [defaultFilters]="row.filters || []"
                      [showSimpleSearch]="false"
                      [waitForParent]="false"
                      [exportingEnabled]="false"
                      (filtersChange2)="onRowFiltersChange2($event, row)"
                      [useMuiLayout]="true"
                      [isDataSetFilterButton]="true"
                      [showFilterBuilder]="false"
                      (popoverStateChange)="onPopoverStateChange($event, i)"
                      [totalWorkflows]="rows?.length || 0"
                      [rowIndex]="i"
                      [dataSetConfig]="dataSetConfig"
                      [isNoData]="isNoData"
                      [hasFewData]="hasFewData">
                    </wm-filter-builder>
                  </div>
                </div>

                <wm-filter-builder
                  *ngIf="row.workflowId && row.filterParams"
                  [id]="row.filterBuilderId"
                  [params]="row.filterParams"
                  [defaultFilters]="row.filters || []"
                  [showSimpleSearch]="false"
                  [waitForParent]="false"
                  [exportingEnabled]="false"
                  (filtersChange2)="onRowFiltersChange2($event, row)"
                  [useMuiLayout]="true"
                  [isDataSetFilterButton]="true"
                  [showFilterBuilder]="true"
                  [externalState]="popoverStateMap[i]">
                </wm-filter-builder>
              </div>
            </ng-container>
          </div>

          <div class="add-workflow" (click)="addWorkflow()">
            <wm-common-text [data]="{ text: '+ Add Workflow' }"></wm-common-text>
          </div>
        </div>
      </div>

      <div class="workflow-right-scroll">
        <div class="workflow-right-inner">
          <div class="workflow-header-row">
            <ng-container *ngIf="(columns?.length || 0) > 0">
              <div
                class="header-cell workflow-title-name"
                *ngFor="let col of columns; trackBy: trackColumnByName"
                [attr.data-column-name]="col?.name"
                [class.is-hovered]="isColumnHovered(col)"
                [class.is-drag-over]="dragOverColumnName === col?.name"
                [draggable]="canDragColumns()"
                (mouseenter)="onHeaderMouseEnter(col, $event)"
                (mouseleave)="onHeaderMouseLeave(col)"
                (dragstart)="onHeaderDragStart(col)"
                (dragend)="onHeaderDragEnd()"
                (dragover)="onHeaderDragOver($event, col)"
                (drop)="onHeaderDrop($event, col)">
                <div class="column-header">
                  <div class="header-cell-text" [title]="getColumnHeaderText(col)">
                    <wm-common-text [data]="{ text: getColumnHeaderText(col) }"></wm-common-text>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <div class="workflow-body-rows" *ngIf="(rows?.length || 0) > 0">
            <div
              class="workflow-data-row"
              #workflowDataRowElement
              *ngFor="let row of rows; trackBy: trackRowByWorkflow">
              <div class="cell" *ngFor="let col of columns; trackBy: trackColumnByName">
                <button
                  type="button"
                  *ngIf="row.workflowId && (!row[col.name] || row[col.name]?.length === 0)"
                  class="cell-add-btn always-visible"
                  (click)="openCellDropdown(row, col, $event)">
                  <mat-icon>add</mat-icon>
                </button>

                <div *ngIf="row[col.name]?.length">
                  <div class="cell-value-wrapper" *ngFor="let value of row[col.name]; let i = index">
                    <wm-common-text [data]="{ text: value }"></wm-common-text>

                    <div class="cell-actions">
                      <button type="button" class="cell-icon" (click)="openCellDropdown(row, col, $event)">
                        <mat-icon>add</mat-icon>
                      </button>

                      <button type="button" class="cell-icon" (click)="deleteCellValue(row, col, i)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>

                <div
                  class="entity-dropdown"
                  *ngIf="activeCellRow === row && activeCellColumn === col"
                  [style.top.px]="dropdownBottom === null ? dropdownTop : null"
                  [style.bottom.px]="dropdownBottom"
                  [style.left.px]="dropdownLeft">
                  <div class="entity-search">
                    <wm-common-textfield
                      [data]="{
                        placeholder: 'Search',
                        value: entitySearch
                      }"
                      (valueChange)="onEntitySearchChange($event)">
                    </wm-common-textfield>
                  </div>

                  <div class="entity-options">
                    <div
                      class="entity-option"
                      *ngFor="let entity of filteredEntities"
                      (click)="selectCellEntity(row, col, entity)">
                      {{ entity.header || entity.label || entity.templateCode || entity.name }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="header-icon-cell">
        <button type="button" class="add-column-btn" (click)="openColumnSettings()">
          <mat-icon fontSet="material-symbols-outlined">add_column_left</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="hoveredColumn as hoveredColumnValue">
    <div
      class="column-top-actions floating-column-actions"
      [style.top.px]="columnActionsTop"
      [style.left.px]="columnActionsLeft"
      (mouseenter)="onColumnActionsEnter(hoveredColumnValue)"
      (mouseleave)="onColumnActionsLeave(hoveredColumnValue)">
      <button
        type="button"
        class="column-icon drag-handle"
        *ngIf="canDragColumns()"
        aria-label="Drag column">
        <mat-icon>drag_indicator</mat-icon>
      </button>

      <button
        type="button"
        class="column-icon"
        *ngIf="canMoveColumnLeft(hoveredColumnValue)"
        (click)="requestColumnMoveLeft(hoveredColumnValue)"
        aria-label="Move column left">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <button
        type="button"
        class="column-icon"
        (click)="requestColumnEdit(hoveredColumnValue)"
        aria-label="Column settings">
        <mat-icon>settings</mat-icon>
      </button>

      <!-- Added by Amisha on 05/21/2026 to match legacy dataset behavior by
           hiding delete for protected/system columns only. -->
      <button
        type="button"
        class="column-icon"
        *ngIf="canDeleteColumn(hoveredColumnValue)"
        (click)="requestColumnDelete(hoveredColumnValue)"
        aria-label="Delete column">
        <mat-icon>delete</mat-icon>
      </button>

      <button
        type="button"
        class="column-icon"
        *ngIf="canMoveColumnRight(hoveredColumnValue)"
        (click)="requestColumnMoveRight(hoveredColumnValue)"
        aria-label="Move column right">
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </ng-container>

  <wm-common-confirmation-modal
    [data]="deleteWorkflowConfirmModalData"
    (onYesClick)="confirmDeleteWorkflow()"
    (onNoClick)="closeDeleteWorkflowModal()">
  </wm-common-confirmation-modal>

  <wm-common-confirmation-modal
    [data]="deleteColumnConfirmModalData"
    (onYesClick)="confirmDeleteColumn()"
    (onNoClick)="closeDeleteColumnModal()">
  </wm-common-confirmation-modal>

  <wm-common-confirmation-modal
    [data]="deleteCellValueConfirmModalData"
    (onYesClick)="confirmDeleteCellValue()"
    (onNoClick)="closeDeleteCellValueModal()">
  </wm-common-confirmation-modal>
</div>
